import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import { Button, Card, StandaloneScreen } from '../../../components/app2';

const PrivacyPolicy = () => {
    const navigate = useNavigate();

    const handleBack = () => {
        if (window.history.length > 1) {
            navigate(-1);
        } else {
            navigate('/login');
        }
    };

    return (
        <StandaloneScreen
            maxWidth={880}
            align="top"
            title="Aviso de privacidad — PaySlip"
            actions={(
                <Button variant="outline" size="sm" icon="arrow_back" onClick={handleBack}>
                    Volver
                </Button>
            )}
        >
            <Card>
                    {/* Title */}
                    <div className="text-center mb-8">
                        <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full mb-4">
                            <Icon name="Shield" size={32} className="text-primary" />
                        </div>
                        <h1 className="text-3xl font-bold text-foreground">Aviso de Privacidad</h1>
                        <p className="text-muted-foreground mt-2">
                            Última actualización: Diciembre 2025
                        </p>
                    </div>

                    {/* Content Sections */}
                    <div className="max-w-none">
                        <p className="text-muted-foreground leading-relaxed">
                            En cumplimiento al deber de resguardo de información y de datos personales y con fundamento en lo dispuesto por los artículos 3 fracción I, 8, 12, 15, 16 y demás relativos de la Ley de Protección de los Datos Personales en Posesión de Particulares, <strong>AS BERMUDEZ & ASOCIADOS</strong>, pone a su disposición el presente Aviso de Privacidad.
                        </p>

                        <section className="mt-8">
                            <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                                <Icon name="Building2" size={20} className="mr-2 text-primary" />
                                Identidad y domicilio del responsable
                            </h2>
                            <p className="text-muted-foreground leading-relaxed">
                                <strong>AS BERMUDEZ & ASOCIADOS</strong>, ubicado en ESTRELLA 54, GUERRERO, CUAUHTÉMOC, CIUDAD DE MÉXICO, C.P. 06300, es la persona responsable del uso y protección de sus datos personales.
                            </p>
                        </section>

                        <section className="mt-8">
                            <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                                <Icon name="Target" size={20} className="mr-2 text-primary" />
                                Fines para los que utilizaremos sus datos personales
                            </h2>
                            <p className="text-muted-foreground mb-3">
                                Los datos personales que recabamos, los utilizaremos para las siguientes finalidades primarias:
                            </p>
                            <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
                                <li>Dar de alta su organización en nuestro portal</li>
                                <li>Establecer una relación comercial</li>
                                <li>Facturación y cobro de servicio</li>
                            </ul>
                            <p className="text-muted-foreground mt-4">
                                Para cumplir con las finalidades descritas en este Aviso de Privacidad, <strong>AS BERMUDEZ & ASOCIADOS</strong> no utilizará sus datos personales para finalidades secundarias.
                            </p>
                        </section>

                        <section className="mt-8">
                            <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                                <Icon name="Database" size={20} className="mr-2 text-primary" />
                                Datos personales que utilizaremos
                            </h2>
                            <p className="text-muted-foreground mb-3">
                                Para llevar a cabo las finalidades descritas en este Aviso de Privacidad, haremos uso de los siguientes datos personales:
                            </p>
                            <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
                                <li>Datos de identificación</li>
                                <li>Datos de contacto</li>
                                <li>Datos laborales</li>
                                <li>Datos financieros</li>
                            </ul>
                        </section>

                        <section className="mt-8">
                            <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                                <Icon name="Share2" size={20} className="mr-2 text-primary" />
                                Transferencia de datos
                            </h2>
                            <p className="text-muted-foreground leading-relaxed">
                                Bajo ninguna circunstancia <strong>AS BERMUDEZ & ASOCIADOS</strong> compartirá sus datos personales con terceros, salvo por requerimientos legales. Los datos serán utilizados exclusivamente para fines señalados en este Aviso de Privacidad.
                            </p>
                        </section>

                        <section className="mt-8">
                            <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                                <Icon name="Lock" size={20} className="mr-2 text-primary" />
                                Datos personales sensibles
                            </h2>
                            <p className="text-muted-foreground leading-relaxed">
                                <strong>AS BERMUDEZ & ASOCIADOS</strong>, bajo ninguna circunstancia solicitará datos personales sensibles.
                            </p>
                        </section>

                        <section className="mt-8 bg-muted rounded-lg p-6">
                            <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                                <Icon name="Key" size={20} className="mr-2 text-primary" />
                                Derechos ARCO
                            </h2>
                            <p className="text-muted-foreground mb-4">
                                Usted tiene derecho a ejercer sus derechos de acceso, rectificación, cancelación u oposición de sus datos personales. Los Derechos ARCO comprenden:
                            </p>
                            <div className="grid gap-4 md:grid-cols-2">
                                <div className="bg-card rounded-lg p-4 border border-border">
                                    <h3 className="font-semibold text-foreground mb-2">Acceso</h3>
                                    <p className="text-sm text-muted-foreground">
                                        El derecho que tienes a conocer qué datos tenemos de ti, así como para saber cómo los usamos o compartimos.
                                    </p>
                                </div>
                                <div className="bg-card rounded-lg p-4 border border-border">
                                    <h3 className="font-semibold text-foreground mb-2">Rectificación</h3>
                                    <p className="text-sm text-muted-foreground">
                                        El derecho a solicitar la rectificación de tus datos si están incorrectos, inexactos o incompletos.
                                    </p>
                                </div>
                                <div className="bg-card rounded-lg p-4 border border-border">
                                    <h3 className="font-semibold text-foreground mb-2">Cancelación</h3>
                                    <p className="text-sm text-muted-foreground">
                                        El derecho a pedir que eliminemos tu información, a partir de su bloqueo y posterior supresión definitiva.
                                    </p>
                                </div>
                                <div className="bg-card rounded-lg p-4 border border-border">
                                    <h3 className="font-semibold text-foreground mb-2">Oposición</h3>
                                    <p className="text-sm text-muted-foreground">
                                        El derecho a indicar una causa legítima por la cual debemos dejar de usar tus datos personales.
                                    </p>
                                </div>
                            </div>
                        </section>

                        <section className="mt-8">
                            <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                                <Icon name="FileText" size={20} className="mr-2 text-primary" />
                                Ejercicio de Derechos ARCO
                            </h2>
                            <p className="text-muted-foreground mb-4">
                                Para el ejercicio de cualquiera de los Derechos ARCO, usted podrá presentar la solicitud respectiva a través de los siguientes medios de correo electrónico:
                            </p>
                            <div className="bg-muted rounded-lg p-4 space-y-2">
                                <div className="flex items-center space-x-2 text-muted-foreground">
                                    <Icon name="Mail" size={16} className="text-primary" />
                                    <a href="mailto:soporte-tecnico@payslip.com" className="hover:text-primary transition-colors">
                                        soporte-tecnico@payslip.com
                                    </a>
                                </div>
                                <div className="flex items-center space-x-2 text-muted-foreground">
                                    <Icon name="Mail" size={16} className="text-primary" />
                                    <a href="mailto:Ventas@payslip.com" className="hover:text-primary transition-colors">
                                        Ventas@payslip.com
                                    </a>
                                </div>
                                <div className="flex items-center space-x-2 text-muted-foreground">
                                    <Icon name="Mail" size={16} className="text-primary" />
                                    <a href="mailto:payslipmex@gmail.com" className="hover:text-primary transition-colors">
                                        payslipmex@gmail.com
                                    </a>
                                </div>
                            </div>
                            <p className="text-muted-foreground mt-4">
                                La solicitud debe incluir:
                            </p>
                            <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
                                <li>Su nombre y domicilio completos</li>
                                <li>Copia de un documento que acredite su identidad</li>
                                <li>Una descripción clara del Derecho ARCO que desea ejercer</li>
                                <li>Cualquier información que ayude a localizar sus datos personales</li>
                            </ul>
                            <p className="text-muted-foreground mt-4">
                                PaySlip responderá a su solicitud dentro de los <strong>15 días hábiles</strong> siguientes a la fecha en que se envió y recibió dicha solicitud.
                            </p>
                        </section>

                        <section className="mt-8">
                            <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                                <Icon name="XCircle" size={20} className="mr-2 text-primary" />
                                Revocación del consentimiento
                            </h2>
                            <p className="text-muted-foreground leading-relaxed">
                                Usted puede limitar el uso o divulgación de sus datos personales dirigiendo la solicitud correspondiente a nuestro Departamento de Datos Personales, siguiendo el procedimiento aplicable al ejercicio de los Derechos ARCO.
                            </p>
                        </section>

                        <section className="mt-8">
                            <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                                <Icon name="RefreshCw" size={20} className="mr-2 text-primary" />
                                Cambios en el aviso de privacidad
                            </h2>
                            <p className="text-muted-foreground leading-relaxed">
                                El presente aviso de privacidad puede sufrir modificaciones, cambios o actualizaciones derivadas de nuevos requerimientos legales; de nuestras propias necesidades por los servicios que ofrecemos; de nuestras prácticas de privacidad; de cambios en nuestro modelo de negocio, o por otras causas.
                            </p>
                            <p className="text-muted-foreground mt-4">
                                Nos comprometemos a mantenerlo informado sobre los cambios que pueda sufrir el presente aviso de privacidad, a través de nuestra página web{' '}
                                <a
                                    href="https://payslip.mx/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-primary hover:underline"
                                >
                                    https://payslip.mx/
                                </a>
                            </p>
                        </section>

                        <section className="mt-8 rounded-lg p-6 a2-note--ok" style={{ background: 'var(--ok-soft)', border: '1px solid var(--ok)' }}>
                            <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                                <Icon name="CheckCircle" size={20} style={{ color: 'var(--ok)', marginRight: 8 }} />
                                Consentimiento
                            </h2>
                            <p className="text-muted-foreground leading-relaxed">
                                Consiento que mis datos personales sean tratados de conformidad con los términos y condiciones informados en el presente aviso de privacidad.
                            </p>
                        </section>

                        <section className="mt-8">
                            <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
                                <Icon name="MapPin" size={20} className="mr-2 text-primary" />
                                Contacto
                            </h2>
                            <div className="bg-muted rounded-lg p-4">
                                <p className="text-muted-foreground">
                                    <strong>Departamento de Datos Personales</strong>
                                </p>
                                <p className="text-muted-foreground mt-2">
                                    Domicilio: Estrella 54, Guerrero, Alcaldía Cuauhtémoc, Ciudad de México, C.P. 06300
                                </p>
                            </div>
                        </section>
                    </div>

                    {/* Footer Navigation */}
                    <div className="mt-8 pt-6 border-t border-border flex flex-col sm:flex-row justify-between items-center gap-4">
                        <Link
                            to="/terms-of-service"
                            className="flex items-center space-x-2 text-primary hover:text-primary/80 transition-colors"
                        >
                            <Icon name="FileText" size={16} />
                            <span>Ver Términos y Condiciones</span>
                        </Link>
                        <button
                            onClick={handleBack}
                            className="flex items-center space-x-2 px-6 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors"
                        >
                            <Icon name="ArrowLeft" size={16} />
                            <span>Volver</span>
                        </button>
                    </div>
            </Card>

            <p style={{ font: "500 .82rem 'Hanken Grotesk'", color: 'var(--muted)', textAlign: 'center', margin: '18px 0 0' }}>
                © {new Date().getFullYear()} PaySlip · Recibos de nómina
            </p>
        </StandaloneScreen>
    );
};

export default PrivacyPolicy;
